<template>
  <div>
    <div v-if="loading" class="has-text-centered" style="padding: 4rem 0;">
      <b-loading :active="loading" :is-full-page="false"></b-loading>
    </div>
    <div v-else-if="error" class="has-text-centered" style="padding: 4rem 0;">
      <h1 class="is-size-3" style="vertical-align: middle">
        404 Página no encontrada
      </h1>
    </div>
    <div v-else>
      <GuiaInterpretacion
        v-if="showResultsGuide"
        :proceso="proceso"
        @selectSection="showResultsGuide = false"
      />
      <Resultados v-else :proceso="proceso" />
    </div>
  </div>
</template>

<script>
import apiServices from "@/services/yungol-services";
import Resultados from "./Resultados.vue";
import GuiaInterpretacion from "./GuiaInterpretacion.vue";

export default {
  name: "ShareLideres",
  components: { Resultados, GuiaInterpretacion },
  data() {
    return {
      loading: true,
      error: false,
      proceso: {},
      showResultsGuide: true,
    };
  },
  async created() {
    const { id } = this.$route.params;
    if (!id) {
      this.error = true;
      this.loading = false;
      return;
    }
    try {
      const res = await apiServices.get(`/proceso-lider-shared/${id}`);
      this.proceso = res.data;
    } catch (e) {
      console.log(e);
      this.error = true;
    } finally {
      this.loading = false;
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/components/lideres/ShareLideres.vue